var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_260_1970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 15C6.14348 15 4.36301 14.2625 3.05025 12.9497C1.7375 11.637 1 9.85652 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85652 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85652 15 8 15ZM8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16Z",
    fill: "#799AA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9703 4.96979C10.9632 4.9767 10.9565 4.98404 10.9503 4.99179L7.47734 9.41679L5.38434 7.32279C5.24216 7.19031 5.05412 7.11819 4.85982 7.12162C4.66551 7.12505 4.48013 7.20376 4.34272 7.34117C4.2053 7.47858 4.12659 7.66397 4.12316 7.85827C4.11974 8.05257 4.19186 8.24062 4.32434 8.38279L6.97034 11.0298C7.04162 11.1009 7.1265 11.157 7.21992 11.1946C7.31334 11.2323 7.41339 11.2507 7.51408 11.2488C7.61478 11.247 7.71407 11.2249 7.80604 11.1838C7.898 11.1427 7.98074 11.0835 8.04934 11.0098L12.0413 6.01979C12.1773 5.87712 12.2516 5.68669 12.2482 5.48966C12.2449 5.29263 12.1641 5.10484 12.0234 4.96689C11.8827 4.82893 11.6933 4.7519 11.4963 4.75244C11.2992 4.75299 11.1103 4.83106 10.9703 4.96979Z",
    fill: "#799AA9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_260_1970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedAll);
export default __webpack_public_path__ + "static/media/CheckedAll.9bf9cf94f5580f8c86acbb2c6fbbc661.svg";
export { ForwardRef as ReactComponent };